import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "uk-container uk-margin-large-top" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("p", null, "Loading", -1)
        ]))]))
      : _createCommentVNode("", true),
    _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Choose Factoring Company", -1)),
    _createVNode(_component_FilterableDropdown, {
      id: "DropOffName",
      options: _ctx.billingCustomers,
      label: "name",
      class: "uk-form-width-large uk-align-center",
      value: _ctx.customerName,
      onInput: _ctx.setCustomer,
      onSearchChange: _ctx.onBillingCustomerSearch,
      components: { OpenIndicator: null, Deselect: null }
    }, null, 8, ["options", "value", "onInput", "onSearchChange"]),
    (_ctx.editingFactoringCompany)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveFactoringCompany && _ctx.saveFactoringCompany(...args))),
          class: "uk-button uk-button-primary uk-margin-left uk-width-1-3"
        }, " Save "))
      : (_openBlock(), _createElementBlock("button", {
          key: 2,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveFactoringCompany && _ctx.saveFactoringCompany(...args))),
          disabled: "",
          class: "uk-button uk-button-primary uk-margin-left uk-width-1-3"
        }, " Save "))
  ]))
}